import { MenuItem, styled } from "@mui/material";
import theme from "common/theme/theme";

const DialogDropdownMenuItem = styled(MenuItem)({
    '&.Mui-selected': {
      backgroundColor: 'transparent',
    },
    '&:hover, &.Mui-selected:hover': {
      backgroundColor: 'transparent',
      color: theme.palette.primary.light,
    },
  });

export default DialogDropdownMenuItem;
